import type { Journey, Level } from '@/features/journeys'
import { sortByPosition } from '@/shared/lib/sort'

/**
 * A level's predecessor is the level right before it in the SAME journey,
 * walking stages and levels by position (stage boundaries are crossed,
 * journey boundaries never are). The first level of a journey has no
 * predecessor — journeys are independent progressions, so a level must
 * never depend on another journey's progress.
 */
export function findPreviousLevel(
  journeys: Journey[],
  levelId: number
): Level | null {
  for (const journey of journeys) {
    let previousLevel: Level | null = null

    const stages = [...(journey.active_stages ?? [])].sort(sortByPosition)

    for (const stage of stages) {
      const levels = [...(stage.active_levels ?? [])].sort(sortByPosition)

      for (const level of levels) {
        if (level.id === levelId) {
          return previousLevel
        }
        previousLevel = level
      }
    }
  }

  return null
}
